import React, { useEffect, useState, useContext } from 'react';
import { PushNotificationsContext, usePushNotifications } from '../contexts/PushNotificationsContext';


import errorIcon   from  '../assets/PushNotifications/error-icon.svg';
import successIcon from  '../assets/PushNotifications/success-icon.svg';
import warningIcon from  '../assets/PushNotifications/warning-icon.svg';
import neutralIcon from  '../assets/PushNotifications/message-icon.svg';

import '../../src/styles/PushNotifications.css';

function PushNotifications() {

    //here only need to read the value to show the pushNotification
    const { contentPushNotification }    = usePushNotifications();

    const notificationStyles = {
        
        'Mensagem': { style: { backgroundColor: '#E3E3E3' }, icon: neutralIcon,   bg:  {style: { backgroundColor: '#eeeeee' }},    timeout: 8000 },
        'Sucesso' : { style: { backgroundColor: '#c5ffd6' }, icon: successIcon,   bg:  {style: { backgroundColor: '#eaffee' }},    timeout: 8000 },
        'Aviso'   : { style: { backgroundColor: '#fff2cc' }, icon: warningIcon,   bg:  {style: { backgroundColor: '#fffff4' }},    timeout: 8000 },
        'Erro'    : { style: { backgroundColor: '#f4cccc' }, icon: errorIcon,     bg:  {style: { backgroundColor: '#fff0f0' }},    timeout: 8000 },
    
    };
    
    const getNotificationContent = (title) => {
        return contentPushNotification[title] || notificationStyles[title];
    };

    const { style, icon, bg } = getNotificationContent(contentPushNotification.title || 'Mensagem')
    
    const openPushNotification = () => {
        
        const element = document.querySelector('.notification');
        element.classList.remove('exiting')

        const { timeout } = getNotificationContent(contentPushNotification.title);
        const timer = setTimeout(() => {
           element.classList.add('exiting');


         }, timeout);

         return () => clearTimeout(timer);
    };

    const closePushNotification = () => {
        const element = document.querySelector('.notification');
        element.classList.add('exiting');
    };


    useEffect(() => {
        
        if (contentPushNotification.title) {
            openPushNotification();
        }else{
            closePushNotification();
        }
    }, [contentPushNotification]);


    const pushContent = contentPushNotification.message;
    

    return (
        <div 
            id="toastNotification" 
            className="notification flex items-center fixed right-5 bottom-5 [box-shadow:rgba(99,_99,_99,_0.2)_0px_2px_8px_0px] w-[100%] max-w-xs p-2 text-gray-500 rounded-lg shadow-sm relative" 
            role="alert" 
            style={bg.style}
        >

            <div 
                className="ml-1 mr-1 inline-flex items-center justify-center shrink-0 w-8 h-8 text-orange-500 rounded-lg" 
                style={style}
            >
                <img 
                    src={icon} 
                    alt="Warning icon" 
                    height={20} 
                    width={20} 
                />
            </div>
            
            <div className="flex-grow">
                <span className="mr-1 text-[small]">
                    {pushContent}
                </span>
            </div>

            <div className="absolute right-3 top-1/2 -translate-y-1/2 cursor-pointer">
                <svg 
                    className="w-3 h-3 text-gray-500 hover:text-gray-700" 
                    aria-hidden="true" 
                    xmlns="http://www.w3.org/2000/svg" 
                    viewBox="0 0 14 14" 
                    onClick={closePushNotification}
                >
                    <path 
                        stroke="currentColor" 
                        strokeLinecap="round" 
                        strokeLinejoin="round" 
                        strokeWidth="2" 
                        d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
                    />
                </svg>
            </div>

        </div>
    );
}

export default PushNotifications;
